/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcInputFile
 * @description
 * The wcInputFile directive holds the input file related operations. This module is widely used in file upload operations.
 */



// http://stackoverflow.com/questions/17063000/ng-model-for-input-type-file
angular.module('WebCoreModule')
	.directive("wcInputFile", ['_', function (_) {
		return {
			scope: {},
			bindToController: {
				wcInputFile: '=',
				fileTypes: '&'
			},
			controllerAs: 'ctrl',
			controller: ['$scope', '$element', 'WcDataFileService', function($scope, $element, WcDataFileService) {
				var vm = this;

				this.onChange = function (changeEvent) {
					// TODO Just do one at a time
					var files = changeEvent.target.files;
					var fileTypes;
					$scope.$apply(function () {
						if(vm.fileTypes() !== undefined && vm.fileTypes().length > 0) {
							fileTypes =_.map(files, function(item) {
								//noinspection UnnecessaryLocalVariableJS
                                var fileType = WcDataFileService.getFileType(item);
								return fileType;
							})
								.filter(function(extension) {
									return vm.fileTypes().indexOf(extension) >= 0;
								});
						}

						if(!fileTypes || fileTypes.length === files.length) {
							vm.wcInputFile = files;
						} else {
							$element.val(null);
						}
					});
				};


			}],
			link: function (scope, element, attrs, ctrl) { // jshint ignore:line
				element.bind('change', ctrl.onChange);

				scope.$watch(function() {
					return ctrl.wcInputFile;
				}, function(file) {
					console.log('log');
					if(file === null) {
						element.val(null);
					}
				});
			}
		};
	}]);